const store = app.store;
import validatePermissions from '../../helpers/validatePermissions'

export default () => {
    return new Promise(async (resolve, reject) => {
        if (store.getters['rms_ui/auth/auth_loading']()) {
            //waiting for store to be initialized...;
            const watcher = store.watch(store.getters['rms_ui/auth/auth_loading'], async (val) => {
                watcher(); // stop watching
                let campaign_ids = app.activeMultiCampaigns.map(c => c.id);
                let isValidGuest = validatePermissions(['role.guest'], campaign_ids);
                let isValidAnonymous = validatePermissions(['role.anonymous'], campaign_ids);
                if (isValidGuest.isValid || isValidAnonymous.isValid) {
                    resolve(true);
                } else {
                    reject({path: "/"});
                }
            });
        } else {
            let campaign_ids = app.activeMultiCampaigns.map(c => c.id);
            let isValidGuest = validatePermissions(['role.guest'], campaign_ids);
            let isValidAnonymous = validatePermissions(['role.anonymous'], campaign_ids);
            if (isValidGuest.isValid || isValidAnonymous.isValid) {
                resolve(true);
            } else {
                reject({path: "/"});
            }
        }
    })
}
